export default "82cb0893993f1e0c.svg"